import { render, staticRenderFns } from "./OrderNotesDetailsAndForm.vue?vue&type=template&id=4c8b6d74&scoped=true"
import script from "./OrderNotesDetailsAndForm.vue?vue&type=script&lang=ts"
export * from "./OrderNotesDetailsAndForm.vue?vue&type=script&lang=ts"
import style0 from "./OrderNotesDetailsAndForm.vue?vue&type=style&index=0&id=4c8b6d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b6d74",
  null
  
)

export default component.exports